import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 py-12"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex flex-col md:flex-row gap-6 md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 border border-gold/50 flex items-center justify-center text-gold font-serif">
            T
          </div>
          <div>
            <div className="font-serif text-cream">Tatra 603 Rental</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-cream/40">
              Marek &amp; Dávid Mistina · Slovensko
            </div>
          </div>
        </div>
        <nav className="flex flex-wrap items-center gap-x-8 gap-y-2 text-[12px] uppercase tracking-[0.2em] text-cream/50">
          <a href="#uvod" className="hover:text-gold transition">Úvod</a>
          <a href="#o-nas" className="hover:text-gold transition">O nás</a>
          <a href="#sluzby" className="hover:text-gold transition">Služby</a>
          <a href="#galeria" className="hover:text-gold transition">Galéria</a>
          <a href="#kontakt" className="hover:text-gold transition">Kontakt</a>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="hover:text-gold transition"
          >
            Admin
          </Link>
        </nav>
        <div className="text-[11px] tracking-wider text-cream/40">
          © {new Date().getFullYear()} Tatra 603 Rental
        </div>
      </div>
    </footer>
  );
}
